import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

const twoDigitsFormat = (number: number): string => `${number}`.padStart(2, '0');

/**
 * This date adapter only supports the date format dd.mm.yyyy or d.m.yyyy
 */
@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  private static readonly format = /^\d{1,2}\.\d{1,2}\.\d{4}$/;

  public constructor() {
    super('de-DE');
  }

  public format(date: Date): string {
    const days = twoDigitsFormat(date.getDate());
    const months = twoDigitsFormat(date.getMonth() + 1);
    const year = date.getFullYear();
    return `${days}.${months}.${year}`;
  }

  public parse(value: string): Date | null {
    if (!value || !CustomDateAdapter.format.test(value?.trim())) {
      return null;
    }

    try {
      const [day, month, year] = value.trim().split('.').map(Number);
      return new Date(year, month - 1, day);
    } catch (e) {
      return null;
    }
  }
}
